import { useParams } from 'react-router-dom';

import { VacanciesForm } from 'src/pages/vacancies/components/vacancies-form';
import { IVacancy } from 'src/pages/vacancies/vacancies.interfaces';

const VacancyDetailsEdit = ({
  vacancy,
  onClickCancelBtn,
}: {
  vacancy: IVacancy;
  onClickCancelBtn: () => void;
}) => {
  const params = useParams();
  const vacancyId = params.id?.slice(4);

  return (
    <VacanciesForm
      onClose={onClickCancelBtn}
      onSuccess={onClickCancelBtn}
      vacancyId={vacancyId}
      initialValues={{
        ...vacancy,
        jobLocationId: vacancy.jobLocation._id,
        companyId: vacancy.company._id,
        jobId: vacancy.job._id,
        departmentId: vacancy.department._id,
      }}
    />
  );
};

export default VacancyDetailsEdit;
